export const CHART_PIE_COLORS = ['#00A89D', '#A0E4DD', '#006B64', '#F9EAC3']

export const CHART_COLUMN_COLORS = ['#99DDD8', '#00A89D', '#006B64', '#F9EAC3', '#F3AA41', '#7E4602', '#80BBDF', '#0076BE', '#003B5F', '#F2ABD1']

export const CHART_RANGE_COLORS = ['#F9EAC3', '#F3AA41', '#7E4602', '#80BBDF', '#0076BE']

export const CHART_COLOR_FONT = '#333335'

export const ERROR_COLOR = '#AC3431'

export const SUCCESS_COLOR = '#61A961'

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const MAX_BLEND_AGE_SOURCES = 12

// @ts-ignore
export const isCypressTest = typeof Cypress !== 'undefined'

export const ROLES = {
  APPLICATION_ADMIN: 'BM_ApplicationAdmin',
  APPLICATION_USER: 'BM_ApplicationUser',
}

export const FEATURES_FLAGS = {
  SURVEY_REPORT_LIMIT_DATA_VARIABLES: 'SurveyReportLimitDataVariables',
  SURVEY_REPORT_LIMIT_SPECIALTIES: 'SurveyReportLimitSpecialties',
  MARKET_POSITIONING_HIDE_INCUMBENT_COLUMNS_PHYSICIAN: 'market-positioning-hide-incumbent-columns-physician',
  MARKET_POSITIONING_HIDE_INCUMBENT_COLUMNS_APP: 'market-positioning-hide-incumbent-columns-app',
  ENABLE_MP_EXPANDED_LABO: 'MPExpandedLabo',
  MARKET_UPLOAD_FACULTY_RANK: 'MarketUploadFacultyRank',
  ENABLE_ADMIN_PAGE: 'EnableAdminPage',
  ENABLE_GRID_HIDE_COLUMNS: 'EnableGridHideColumns',
  EXPERT_REVIEW_BUTTON: 'ExpertReviewButton',
}

export const USER_MESSAGES = {
  EXPORT_TAKING_LONGER: {
    title: 'Export Taking Longer',
    message: 'The export may take some time due to a large amount of data. Please stay on the page until it completes.',
  },
  EXPORT_FAILED: {
    title: 'Export Failed',
    message: 'The export failed. Please try again.',
  },
  EXPORT_SUCCESS: {
    title: 'Exported data',
    message: 'The data was exported successfully',
  },
}

export const TOAST_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
  ALERT: 'alert',
}

export const PAGES = {
  MARKET_LIBRARY: 'Market Library',
  ORG_LIBRARY: 'Organization Library',
  SURVEY_REPORT: 'Survey Report',
  BLEND_AGE: 'Blend Age',
  COMPILE_CUSTOM: 'Compile Custom',
  MARKET_POSITIONING: 'Market Positioning',
  AAG_ENHANCED: 'At a glance',
}

export const FILTER_OPPORTUNITY_ASSESSMENTS_TYPE = {
  WORK_RVU: 'work_rvu_opp_assessment',
  COLLECTIONS: 'collections_opp_assessment',
}

export const AAG_ENHANCED_COMPENSATION_TABLE_HEADERS = {
  METRIC: { Order: 1, Title: '', Field: 'metric' },
  AMOUNT: { Order: 2, Title: 'Amount', Field: 'amount' },
  FTE: { Order: 3, Title: 'FTE', Field: 'fte' },
  INCUMBENT_COUNT: { Order: 4, Title: 'n', Field: 'incumbent_count' },
  P10: { Order: 5, Title: '10<sup>th</sup> %ile', Field: 'p10' },
  P25: { Order: 6, Title: '25<sup>th</sup> %ile', Field: 'p25' },
  P50: { Order: 7, Title: '50<sup>th</sup> %ile', Field: 'p50' },
  P55: { Order: 8, Title: '55<sup>th</sup> %ile', Field: 'p55' },
  P60: { Order: 9, Title: '60<sup>th</sup> %ile', Field: 'p60' },
  P65: { Order: 10, Title: '65<sup>th</sup> %ile', Field: 'p65' },
  P75: { Order: 11, Title: '75<sup>th</sup> %ile', Field: 'p75' },
  P90: { Order: 12, Title: '90<sup>th</sup> %ile', Field: 'p90' },
  MARKET_POSITION_PERCENTILE: { Order: 13, Title: 'Market %ile', Field: 'market_position_percentile' },
}

export const AAG_ENHANCED_DETAILED_COMPENSATION_TABLE_HEADERS = {
  AMOUNT_HIDDEN: { Order: 2, Title: ' ', Field: 'amount', Type: 'hidden' },
  FTE_HIDDEN: { Order: 3, Title: ' ', Field: 'fte', Type: 'hidden' },
}

export const CASH_COMPENSATION_METRICS = ['Clinical Compensation', 'Leadership Compensation', 'Academic Compensation', 'Total Cash Compensation']
export const PRODUCTIVITY_METRICS = ['Work RVU', 'Clinical TCC per Work RVU', 'Collections', 'Clinical TCC to Collections Ratio']
export const ORDERED_AAG_ENHANCED_METRICS = [
  'Clinical Compensation',
  'Leadership Compensation',
  'Academic Compensation',
  'Total Cash Compensation',
  'Work RVU',
  'Clinical TCC per Work RVU',
  'Collections',
  'Clinical TCC to Collections Ration',
]
